import React, { useEffect, useState } from "react";
import { Checkbox, Input, Select } from "antd";

const formatPhone = (phone: string) => {
  const digits = phone.replace(/\D/g, "");
  if (digits.length === 0) return "";
  // strip leading country code 86 if present
  if (digits.startsWith("86") && digits.length > 11) {
    return digits.slice(-11);
  }
  // if longer than 11, keep last 11 digits to capture main number
  if (digits.length > 11) return digits.slice(-11);
  return digits;
};

type ConfirmChannelKey = "app" | "sms" | "mail";

interface ConfirmChannelCardProps {
  confirmChannels: { app: boolean; sms: boolean; mail: boolean };
  confirmSms: string;
  confirmEmail: string;
  smsCandidates?: string[];
  onChannelChange: (key: ConfirmChannelKey) => void;
  onSmsChange: (val: string) => void;
  onEmailChange: (val: string) => void;
}

const ConfirmChannelCard: React.FC<ConfirmChannelCardProps> = ({
  confirmChannels,
  confirmSms,
  confirmEmail,
  smsCandidates = [],
  onChannelChange,
  onSmsChange,
  onEmailChange,
}) => {
  const [smsOptions, setSmsOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const formattedSms = formatPhone(confirmSms);

  useEffect(() => {
    const formattedCandidates = Array.from(
      new Set(
        smsCandidates
          .filter(Boolean)
          .map((item) => formatPhone(item))
          .filter(Boolean)
      )
    );
    if (formattedCandidates.length) {
      setSmsOptions(
        formattedCandidates.map((v) => ({ value: v, label: v }))
      );
    } else {
      setSmsOptions([]);
    }
  }, [smsCandidates]);

  const handleSmsChange = (val?: string) => {
    const formatted = formatPhone(val || "");
    onSmsChange(formatted);
  };

  return (
    <div className="card confirmChannelCard">
      <div className="cardTitle">客户确认渠道</div>
      <p className="confirmChannelDesc">请选择客户确认订单的渠道及信息</p>
      <div className="confirmChannelDesc">此预购单最多保留7天，期间若活动结束，订单将自动取消</div>
      <div className="confirmChannelList">
        <div className="confirmChannelItem mobilityChannelItem">
          <Checkbox checked={confirmChannels.app} disabled />
          <span className="confirmChannelLabel">掌上赛默飞</span>
        </div>
        <div className="confirmChannelItem">
          <Checkbox
            checked={confirmChannels.sms}
            onChange={() => onChannelChange("sms")}
          />
          <span className="confirmChannelLabel">短信</span>
          <Select
            className="confirmChannelInput"
            placeholder="请选择手机号"
            value={formattedSms || undefined}
            options={smsOptions}
            filterOption={false}
            onChange={handleSmsChange}
            onSearch={handleSmsChange}
          />
        </div>
        <div className="confirmChannelItem">
          <Checkbox
            checked={confirmChannels.mail}
            onChange={() => onChannelChange("mail")}
          />
          <span className="confirmChannelLabel">邮件</span>
          <div className="confirmChannelInput" style={{ minHeight: 36, display: "flex", alignItems: "center" }}>
            {confirmEmail}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmChannelCard;
